export const ProductConstants = {
    GET_PRODUCT: 'GET_PRODUCT',
    SET_PRODUCT: 'SET_PRODUCT'
};